import type { CookieKey } from "./types/cookieKey.types";
import type { DeleteCookieProps } from "./utils/deleteCookie";
import { deleteCookie } from "./utils/deleteCookie";
import type { GetCookieProps } from "./utils/getCookie";
import { getCookie } from "./utils/getCookie";
import type { SetCookieProps } from "./utils/setCookie";
import { setCookie } from "./utils/setCookie";

export const COOKIE_KEY_AJS_ANONYMOUS_ID: CookieKey = "ajs_anonymous_id";

export type DeleteCookieAjsAnonymousIdProps = Omit<DeleteCookieProps, "key">;

export const deleteCookieAjsAnonymousId = ({
  ...props
}: DeleteCookieAjsAnonymousIdProps = {}) =>
  deleteCookie({ key: COOKIE_KEY_AJS_ANONYMOUS_ID, ...props });

export type GetCookieAjsAnonymousIdProps = Omit<GetCookieProps, "key">;

export const getCookieAjsAnonymousId = ({
  ...props
}: GetCookieAjsAnonymousIdProps = {}) =>
  getCookie({ key: COOKIE_KEY_AJS_ANONYMOUS_ID, ...props });

export type SetCookieAjsAnonymousIdProps = Omit<SetCookieProps, "key">;

export const setCookieAjsAnonymousId = ({
  ...props
}: SetCookieAjsAnonymousIdProps) =>
  setCookie({ key: COOKIE_KEY_AJS_ANONYMOUS_ID, ...props });
